import { Inject, Injector, Component } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface SgAsyncGuiDialogContainerContext {
  component: any;
  injector: Injector;
}

@Component({
  selector: 'sg-async-gui-dialog-container',
  template: `<ng-container *ngComponentOutlet="data.component; injector: data.injector"></ng-container>`,
  standalone: false,
})
export class SgAsyncGuiDialogContainer {
  constructor(@Inject(MAT_DIALOG_DATA) public data: SgAsyncGuiDialogContainerContext) {}
}
